import { Button } from '@mui/material'
// import useNotification from 'notification'
import React from 'react'
import { useInDebug } from 'useAuth'
import LaudoPerdasPeriodo from '../../../reports/LaudoPerdasPeriodo'


export default function BotaoRelatorioIndicador({
    laudos,
    apontamentosPorTipo,
    cliente,
    detalhaApontamentos,
    agrupador,
    filters
}) {
    // const { showWarning } = useNotification()
    const IN_DEBUG = useInDebug()
    const gerarRelatorio = () => {

        console.log('laudos', laudos)
        // console.log('laudos', laudos.map(l => {
        //     return {
        //         indicadores: l.strIndicadores,
        //         laudo: l
        //     }
        // }))

        new LaudoPerdasPeriodo({
            laudos,
            apontamentosPorTipo,
            detalhaApontamentos,
            cliente,
            agrupador,
            filters
        }).generate(IN_DEBUG) // false)

    }
    return (
        <><Button style={{ whiteSpace: 'noWrap', minWidth: 'auto' }} onClick={gerarRelatorio}>
            Relatório
        </Button></>
    )
}
